<template>
  <div>
    <div v-if="form.errors.has(field)"
         class="help-block invalid-feedback"
         v-html="form.errors.get(field)"
    ></div>
    <div v-else-if="form.successful"
         class="help-block invalid-feedback"
    > {{ test() }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'HintImport',

  props: {
    form: {
      type: Object,
      required: true
    },

    field: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      success: false
    }
  },

  methods: {
    test () {
      return 'GOOD'
    }
  }

}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/admin/HintImport.vue